import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintinence',
  templateUrl: './maintinence.component.html',
  styleUrls: ['./maintinence.component.scss']
})
export class MaintinenceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
